import React from 'react';
import SecurePurchaseBadgeIcon from '../../../icons/general/SecurePurchaseBadgeIcon';

interface SecurityBadgeSectionProps {
  show: boolean;
  textColor: string;
}

export const SecurityBadgeSection: React.FC<SecurityBadgeSectionProps> = ({ show, textColor }) => {
  if (!show) return null;

  return (
    <div className="flex items-center" style={{ color: textColor }}>
      <SecurePurchaseBadgeIcon />
    </div>
  );
};
